module.exports = __webpack_public_path__ + "static/CloudflareSase-6d3392bca412222c006174390ac2243a.png";